import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "@learningblocks/shared-components/lib/FormattedMessage";
import { sanitizeConfigOptions } from "@labxchange/util-sanitization";
import cName from "./style.module.scss";

/**
 * Question
 *    -Component accepts the HTML question text and render it to HTML
 */

export function Question(props) {
  return (
    <div className={`${cName.question} ${props.className}`}>
      <FormattedMessage
        string={props.text}
        sanitizeConfig={sanitizeConfigOptions.BlockText}
        description=""
      />
    </div>
  );
}

Question.propTypes = {
  /**
   * Text to be  displayed as question
   * Expects a string p tag
   */
  text: PropTypes.string.isRequired,
  /**
   * ClassName to set on the tag
   */
  className: PropTypes.string,
};

Question.defaultProps = {
  text: "",
  className: "",
};
